var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen",class:{ 'with-background': _vm.background }},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470dd630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/phone/LockScreen.vue
// module id = null
// module chunks = 